export default {
  setRemove ({ state, commit }, action) {
    commit('setAttr', {
      name: 'title',
      value: '削除の確認'
    })

    commit('setAttr', {
      name: 'body',
      value: '本当に削除しますか？'
    })

    commit('setAttr', {
      name: 'action',
      value: action
    })

    state.element.show()
  },

  setUpdate ({ state, commit }, action) {
    commit('setAttr', {
      name: 'title',
      value: '変更の確認'
    })

    commit('setAttr', {
      name: 'body',
      value: '本当に変更しますか？'
    })

    commit('setAttr', {
      name: 'action',
      value: action
    })

    state.element.show()
  },

  setExec ({ state, commit }, action) {
    commit('setAttr', {
      name: 'title',
      value: '実行の確認'
    })

    commit('setAttr', {
      name: 'body',
      value: '本当に実行しますか？'
    })

    commit('setAttr', {
      name: 'action',
      value: action
    })

    state.element.show()
  }
}
